import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class MdCheckbox extends Vue {
    @Prop() value?: boolean;
    @Prop() disabled?: boolean;
    @Prop() label?: string;
    @Prop() required?: boolean;
    @Prop() submitted?: boolean;

    $refs!: {
        input: HTMLFormElement
    };
    
    get content() {
        return this.value;
    }

    set content(value) {
        if (!this.disabled) {
            this.$emit('input', value);
            (this.$refs.input as any).classList.remove('error');
        }
    }

    get isRequired() {
        return this.required && !this.value && this.submitted;
    }

    onClick() {
        this.content = !this.content;
        this.$emit('change');
    }
}
